import { ref } from "vue";

const modalVisible = ref(false);
const activityId = ref(null);
const clientId = ref(null);
const report = ref(null);

/* v8 ignore start */
export default () => {
  function showModal(actId, cId, data) {
    activityId.value = actId;
    clientId.value = cId;
    report.value = data;
    modalVisible.value = true;
  }

  function hideModal() {
    modalVisible.value = false;
  }

  return {
    showModal,
    hideModal,
    modalVisible,
    activityId,
    clientId,
    report,
  };
};
/* v8 ignore stop */
